import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createIraApplicationAccountType,
  updateIraApplicationAccountType,
} from '../store/actions/iraFunding/iraFundingActions';
import useApplicationUid from './useApplicationUid';

const useCustodianAccountTypeDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const custodianAccountTypeDispatch = ({
    data,
    params,
    defaultValues,
    onSuccess,
  }) => {
    const shouldSkip = isEqual(params, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data,
      params,
      onSuccess,
    };

    if (defaultValues?.iRAAccountType) {
      dispatch(
        updateIraApplicationAccountType({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createIraApplicationAccountType({
        ...requestData,
      }),
    );
  };

  return { custodianAccountTypeDispatch };
};

export default useCustodianAccountTypeDispatch;
